import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {DEFAULT_SETTINGS} from '../../constants/defaultSettings';
import type {EagGridState} from '../createEagGridStore';

/** Primitive snapshot so status subscriptions never allocate a new object. */
export function selectPdfExportUnavailableReason(state: EagGridState) {
  const loadedIds = new Set(state.rows.map((row) => row.id));
  return match(state)
    .with({disableAllActions: true}, () => 'disabled' as const)
    .when(
      (value) => value.bulkSelectionQueryId !== null,
      () => 'all-filtered' as const
    )
    .when(
      (value) => value.fetchState === 'loading',
      () => 'loading' as const
    )
    .when(
      (value) =>
        value.fetchState !== 'success' ||
        value.queryId === '' ||
        isNil(value.definition) ||
        isNil(value.loadedPageRequest) ||
        value.loadedPageRequest.queryId !== value.queryId ||
        value.loadedPageRequest.limit !== (value.gridSettings ?? DEFAULT_SETTINGS).itemsPerPage ||
        value.loadedPageRequest.offset !==
          value.page * (value.gridSettings ?? DEFAULT_SETTINGS).itemsPerPage,
      () => 'unavailable' as const
    )
    .when(
      (value) => value.selectedRowIds.size === 0,
      () => 'empty' as const
    )
    .when(
      (value) => [...value.selectedRowIds].some((id) => !loadedIds.has(id)),
      () => 'incomplete' as const
    )
    .otherwise(() => null);
}
